export const Post = {
  Paragraph: {
    Type: {
      text: 1,
      personalMessage: 2,
      image: 3,
      youtube: 4,
      attachment: 5,
      video: 6,
      dummyImage: 7,
      audio: 8,
    },
  },
  Type: {
    boardPost: 1,
    notePost: 2,
    brandPost: 3,
  },
  TagType: ['class', 'grade', 'homework'],
  ReviewStatus: {
    pending: 1,
    approved: 2,
    rejected: 3,
  },
};
